export const confirmationMessages = {
  logout: {
    title: 'Logout',
    message: 'Are you sure you want to logout?',
    negativeBtn: 'Cancel',
    positiveBtn: 'Yes',
  },
  enableDeliveryAgent: {
    title: 'Enable',
    message: 'Are you sure you want to enable this agent?',
    negativeBtn: 'Close',
    positiveBtn: 'Enable',
  },
  disableDeliveryAgent: {
    title: 'Disable',
    message: 'Are you sure you want to disable this agent?',
    negativeBtn: 'Close',
    positiveBtn: 'Disable',
  },
  enableBusiness: {
    title: 'Enable',
    message: 'Are you sure you want to enable this business?',
    negativeBtn: 'Close',
    positiveBtn: 'Enable',
  },
  disableBusiness: {
    title: 'Disable',
    message: 'Are you sure you want to disable this business?',
    negativeBtn: 'Close',
    positiveBtn: 'Disable',
  },
  activateUser: {
    title: 'Activate',
    message: 'Are you sure you want to activate this user?',
    negativeBtn: 'Close',
    positiveBtn: 'Activate',
  },
  deactivateUser: {
    title: 'Deactivate',
    message: 'Are you sure you want to deactivate this user?',
    negativeBtn: 'Close',
    positiveBtn: 'Deactivate',
  },
  removeUser: {
    title: 'Confirmation',
    message: 'Are you sure you want to remove this user?',
    negativeBtn: 'Close',
    positiveBtn: 'Remove',
  },
  enableAllPermissions: {
    title: 'Enable',
    message: 'Are you sure you want to enable all the permissions?',
    negativeBtn: 'Close',
    positiveBtn: 'Enable',
  },
  disableAllPermissions: {
    title: 'Disable',
    message: 'Are you sure you want to disable all the permissions?',
    negativeBtn: 'Close',
    positiveBtn: 'Disable',
  },
  enablePermission: {
    title: 'Enable',
    message: 'Are you sure you want to enable permissions?',
    negativeBtn: 'Close',
    positiveBtn: 'Enable',
  },
  disablePermission: {
    title: 'Disable',
    message: 'Are you sure you want to disable permissions?',
    negativeBtn: 'Close',
    positiveBtn: 'Disable',
  },
  resendInvitation: {
    title: 'Confirmation',
    message: 'Are you sure you want to resend the invitation?',
    negativeBtn: 'Close',
    positiveBtn: 'Send',
  },
  removeBusiness: {
    title: 'Confirmation',
    message: 'Are you sure you want to remove this business?',
    negativeBtn: 'Close',
    positiveBtn: 'Remove',
  },

  enableProduct: {
    title: 'Enable',
    message: 'Are you sure you want to enable the product?',
    negativeBtn: 'Close',
    positiveBtn: 'Enable',
  },
  disableProduct: {
    title: 'Disable',
    message: 'Are you sure you want to disable the product?',
    negativeBtn: 'Close',
    positiveBtn: 'Disable',
  },

  activateSubCategory: {
    title: 'Activate',
    message: 'Are you sure you want to activate this sub-category?',
    negativeBtn: 'Close',
    positiveBtn: 'Activate',
  },
  deactivateSubCategory: {
    title: 'Deactivate',
    message: 'Are you sure you want to deactivate this sub-category?',
    negativeBtn: 'Close',
    positiveBtn: 'Deactivate',
  },
  deleteFeaturedCategory: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this featured category details?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  deleteTopCategory: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this category details?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  deleteRole: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this role?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  deleteSubAdmin: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this sub admin?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  deleteTag: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this tag?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  unassignTag: {
    title: 'Unassigned Tag',
    message: 'Are you sure you want to Unassigned this sub admin?',
    negativeBtn: 'Close',
    positiveBtn: 'Unassigned',
  },
  deleteQuestion: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this question?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  deleteSeoLink: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this SEO details?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  suspendBusiness: {
    title: 'Confirmation',
    message: 'Are you sure you want to suspend this business details from listing?',
    negativeBtn: 'Cancel',
    positiveBtn: 'Yes',
  },
  unsuspendBusiness: {
    title: 'Confirmation',
    message: 'Are you sure you want to relist this business details?',
    negativeBtn: 'Cancel',
    positiveBtn: 'Yes',
  },
  deleteBusiness: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this business?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  activateBusiness: {
    title: 'Activate',
    message: 'Are you sure you want to activate this business?',
    negativeBtn: 'Close',
    positiveBtn: 'Activate',
  },
  deactivateBusiness: {
    title: 'Deactivate',
    message: 'Are you sure you want to deactivate this business?',
    negativeBtn: 'Close',
    positiveBtn: 'Deactivate',
  },
  approveBusinessClaim: {
    title: 'Confirmation',
    message: 'Are you sure you want to approve this business claim request?',
    negativeBtn: 'Close',
    positiveBtn: 'Approve',
  },
  deleteCustomer: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this customer?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  activateCustomer: {
    title: 'Activate',
    message: 'Are you sure you want to activate this customer?',
    negativeBtn: 'Close',
    positiveBtn: 'Activate',
  },
  deactivateCustomer: {
    title: 'Deactivate',
    message: 'Are you sure you want to deactivate this customer?',
    negativeBtn: 'Close',
    positiveBtn: 'Deactivate',
  },

  activateBanner: {
    title: 'Activate',
    message: 'Are you sure you want to activate this banner?',
    negativeBtn: 'Close',
    positiveBtn: 'Activate',
  },
  deactivateBanner: {
    title: 'Deactivate',
    message: 'Are you sure you want to deactivate this banner?',
    negativeBtn: 'Close',
    positiveBtn: 'Deactivate',
  },
  deleteBanner: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this banner?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  markResolved: {
    title: 'Confirmation',
    message: 'Are you sure you want to mark this ticket as resolved?',
    negativeBtn: 'Cancel',
    positiveBtn: 'Yes',
  },
  approveEditRequest: {
    title: 'Approve',
    message: 'Are you sure you want to approve this edit request ?',
    negativeBtn: 'Close',
    positiveBtn: 'Approve',
  },
  declineEditRequest: {
    title: 'Decline',
    message: 'Are you sure you want to decline this edit request ?',
    negativeBtn: 'Close',
    positiveBtn: 'Decline',
  },
  deleteNotification: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this notification details?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  enableInventory: {
    title: 'Enable',
    message: 'Are you sure you want to enable this inventory?',
    negativeBtn: 'Close',
    positiveBtn: 'Enable',
  },
  disableInventory: {
    title: 'Disable',
    message: 'Are you sure you want to disable this inventory?',
    negativeBtn: 'Close',
    positiveBtn: 'Disable',
  },
  deleteCategory: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this category?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
  deleteSubCategory: {
    title: 'Confirmation',
    message: 'Are you sure you want to delete this sub category?',
    negativeBtn: 'Close',
    positiveBtn: 'Delete',
  },
}

export const alertMessages = {
  passwordChangedSuccessfully: 'Password changed successfully. Please login again.',
}
